// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3ilNE","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__3Mq-y"};